export default __webpack_public_path__ + "static/media/team4.4c9c4c74.png";